
import Vue from "vue";

export default Vue.extend<Data, {}, Computed, Props>({
  props: {
    isUnread: {
      type: Boolean,
      default: false,
    },
    fillColor: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isDarkMode: false,
    };
  },
  computed: {
    effectiveFillColor() {
      if (this.fillColor) {
        return this.fillColor;
      }
      return this.isDarkMode ? "#ffffff" : "#000000";
    },
  },
  mounted() {
    this.checkDarkMode();
    this.observer = new MutationObserver(this.checkDarkMode);
    this.observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["data-app-theme"],
    });
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    checkDarkMode() {
      this.isDarkMode = document.documentElement.getAttribute("data-app-theme") === "dark";
    },
  },
});

interface Props {
  isUnread: boolean;
  fillColor: string;
}

interface Data {
  isDarkMode: boolean;
  observer?: MutationObserver;
}

interface Computed {
  effectiveFillColor: string;
}
